import { motion, useReducedMotion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Reveal } from '../motion/Reveal';
import { BOT_APP_URL } from '../links';
import arrowUp from '../assets/figma/icons/arrow-up.svg';
import emojiBank from '../assets/figma/icons/emoji-bank.png';

/** Figma 59:11488 — the closing call to action. */
export function Cta() {
  const { t } = useTranslation();
  const still = useReducedMotion();
  return (
    <section className="flex flex-col items-center gap-[24px] lg:gap-[44px]">
      <Reveal>
        <div className="flex w-full flex-col items-center gap-[12px] px-[16px] text-center font-display leading-[0.95] text-black lg:w-[930px] lg:gap-[26px] lg:px-0 lg:leading-[0.9]">
          {/* The emoji ships as an image rather than a character: every platform
              draws 🏦 differently, and the design calls for the one Figma shows. */}
          <p className="flex w-full items-center justify-center gap-[0.22em] text-[28px] font-medium sm:text-[40px] lg:text-[72px]">
            {t('cta.line1Before')}
            <img src={emojiBank} alt="" className="inline-block h-[0.92em] w-auto" />
            {t('cta.line1After')}
          </p>
          <p className="w-full text-[52px] font-semibold sm:text-[76px] lg:text-[144px]">{t('cta.line2')}</p>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <motion.a
          href={BOT_APP_URL}
          target="_blank"
          rel="noopener noreferrer"
          whileHover={still ? undefined : { scale: 1.05 }}
          whileTap={still ? undefined : { scale: 0.97 }}
          className="flex items-center justify-center gap-[3px] whitespace-pre rounded-[999px] bg-primary px-[16px] py-[10px] text-[15px] font-medium text-white"
        >
          {t('cta.button')}
          <img src={arrowUp} alt="" className="size-[16px]" />
        </motion.a>
      </Reveal>
    </section>
  );
}
